// extracted by mini-css-extract-plugin
export var button = "BackToTopBtn-module--button--3NvJw";
export var bxTextTruncateEnd = "BackToTopBtn-module--bx--text-truncate--end--3yVYX";
export var bxTextTruncateFront = "BackToTopBtn-module--bx--text-truncate--front--1I5Up";